import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ProductCard from "../components/Product";
import UnisexPerfumeHeader from "../components/perfumeComponent/unisexPerfumeHeader";
import { categoryService } from "../services/categoryService";

const UnisexPage = () => {
    const { t } = useTranslation();
    const [categories, setCategories] = useState([]);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const cacheKey = "cached_categories_unisex";

        // 1) Load cached data first (instant UI)
        const cached = localStorage.getItem(cacheKey);
        if (cached) {
            try {
                const parsed = JSON.parse(cached);
                setCategories(parsed);
                setLoading(false);
            } catch (err) {
                console.error("Cache parse error:", err);
            }
        }

        // 2) Fetch newest categories and update UI + cache
        const fetchCategories = async () => {
            try {
                const res = await categoryService.getActiveCategories();

                // Only update if different from cache
                if (JSON.stringify(res) !== cached) {
                    setCategories(res);
                    localStorage.setItem(cacheKey, JSON.stringify(res));
                }
            } catch (error) {
                console.error("Error fetching categories:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchCategories();
    }, []);

    useEffect(() => {
        // Immediate scroll to top
        window.scrollTo(0, 0);
    }, []);

    return (
        <main className="promotion-header shopping-page mt-5" style={{ fontFamily: "'Hanuman', Arial, sans-serif" }}>
            <UnisexPerfumeHeader />
            <ProductCard
                title={t('UNISEX')}
                mode="grid"
                CARDS_PER_ROW={4}
                filterSex="Unisex"
                categories={categories}
                categoriesLoading={loading}
            />
        </main>
    );
};

export default UnisexPage;